export default "__VITE_ASSET__D1DK904a__"